import __request__ from "routing/request";
export function performPurge(idOrName, key, requestOptions) {
  return __request__("POST", `/cluster/system/lookup/tables/${idOrName}/purge`, null, { "key": key }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
